<template>
  <div class="orden-trabajo-imagenes">
    <b-card header="Imágenes de la Órden">
      <b-row v-if="seleccionImagenes">
        <b-col>
          <b-form>
            <b-form-group
              description="Imágenes (jpg, png o jpeg) de hasta 300KB">
              <b-form-file 
                v-model="files" 
                class="mt-3" 
                accept=".jpg, .png, .jpeg" 
                placeholder="Seleccione una o más imágenes o arrastrelas hasta aquí"
                multiple>
              </b-form-file>
              <b-input-group-append 
                  class="filter-search-icons" 
                  @click="agregarImagenes">
                <b-input-group-text>
                  <i class="fa fa-remove"></i>
                </b-input-group-text>
              </b-input-group-append>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>

      <b-row>
        <template
          v-for="{ id, fileName, url, key } in imagenes">
          <b-col :key="key" cols="12" md="4">
            <b-card no-header class="orden-trabajo-imagen">
              <b-img fluid 
                @click="consultarImagen(url)"
                :src="url"></b-img>
              <div 
                  :class="{ 'footer': true, 'readonly': readonly }">
                <b-button 
                  v-if="!readonly"
                  size="sm" variant="danger" class="footer-button" 
                  @click.prevent="borrarImagen(id)">Borrar</b-button>
                <b-button size="sm" variant="primary" class="footer-button" 
                  @click.prevent="descargarImagen(url, fileName)">Descargar</b-button>
              </div>
          </b-card>
          </b-col>
        </template>
      </b-row>

      <div
          v-if="!readonly" 
          class="add-table-btn">
        <div class="list-add-btn" @click.prevent="agregarImagenes">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </div>
      </div>

      <div slot="footer">
        <!-- <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button> -->
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Imagen from  '../shared/imagenModal.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from "vuex-map-fields";

const { mapFields } = createHelpers({
  getterType: "ordentrabajo/getField",
  mutationType: "ordentrabajo/updateField",
});

export default {
  name: 'OrdenesTrabajosImagenes',
  components: {
    appImagen: Imagen,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    ordenTrabajoId: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      files: [],
      uploaded: [],
      seleccionImagenes: false,
      selectedImageUrl: ''
    }
  },
  computed: {
    ...mapFields([
	    'imagenes',
    ]),
  },
  created() {
    let params = {
      ordenTrabajoId: this.ordenTrabajoId,
    }

    this.$store.dispatch('ordentrabajo/getImagenes', params)
      .catch(err => this.showErrorMsj(err));
  },
  methods: {
    borrarImagen (imagenId) {
      if (!this.readonly) {
        let params = {
          ordenTrabajoId: this.ordenTrabajoId,
          imagenId
        }
  
        this.showSpinner();
        this.$store.dispatch('ordentrabajo/removeImagen', params)
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner())
      }

      // this.$emit('borrarImagen', imagenId);
    },
    agregarImagenes() {
      if (!this.readonly) {
        this.seleccionImagenes = !this.seleccionImagenes;
      }
    },
    uploadFiles() {
      if (this.files) {
        if (this.files.length != 0) {
          this.uploaded = [];

          this.showSpinner();

          this.files.forEach(file => {
            let params = {
              ordenTrabajoId: this.ordenTrabajoId,
              file: file
            }

            this.uploaded.push(file);

            this.$store.dispatch('ordentrabajo/addImagen', params)
              .then( () => this.fileUploaded(file))
              .catch( error => {
                this.hideSpinner();
                this.showErrorMsj (error);
              });
          });
        }
      }
    },
    fileUploaded(file) {
      console.log('Uploaded');

      let index = this.uploaded.findIndex(uploadedFile => uploadedFile.name == file.name);

      if (index != -1) {
        this.uploaded.splice(index, 1);

        if (this.uploaded.length == 0) {
          this.files = [];
          this.seleccionImagenes = false;
          this.hideSpinner();
        }
      }
    },
    close() {
      let params = {
        ordenTrabajoId: this.ordenTrabajoId,
        tieneImagenes: false
      }
      if (this.imagenes) {
        if (this.imagenes.length != 0) {
          params.tieneImagenes = true;
        }    
      }

      this.$emit('close', params);
    },
    descargarImagen(imageUrl, imagenName) {
      fetch(imageUrl)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, imagenName);
        });
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    }
  },
  watch: {
    'files' : function(newVal, oldVal) {
      this.uploadFiles();
    },    
  }    
}
</script>

<style scoped>
  .orden-trabajo-imagen {
    border: none;
    padding-top: 10px;
    text-align: center;
  }
  .orden-trabajo-imagen .card-body {
    padding: 0;
  }
  .orden-trabajo-imagen img {
    position: relative;
    margin-bottom: 10px;
    /* width: 100%;
    height: auto; */
    cursor: pointer;
  }
  .orden-trabajo-imagen .footer {
    height: 40px;
    /* min-height: 40px; */
    display: inline-block;
    width: 100%;
  }
  .orden-trabajo-imagen .footer button {
    display: none;
    /* display: inline-block; */
    margin-right: 0;
    width: 48%;
  }
  .orden-trabajo-imagen .footer button:first-of-type {
    margin-right: 4%;
  }
  .orden-trabajo-imagen:hover .footer button {
    display: inline-block;
  }
  @media(max-width:766px){
    .orden-trabajo-imagen .footer button {
      display: inline-block;
    }
  }

  .orden-trabajo-imagen .footer.readonly button {
    width: 100%;
  }
  .orden-trabajo-imagen .footer.readonly button:first-of-type {
    margin-right: 0;
  }

  .orden-trabajo-imagenes .custom-file-input ~ .custom-file-label[data-browse]::after {
    content: 'Buscar' !important;
  }

  .orden-trabajo-imagenes .b-form-file {
    position: relative;
    display: inline-block;
    width: calc(100% - 50px);
  }

  .orden-trabajo-imagenes .filter-search-icons {
    position: relative;
    display: inline-block;
    margin-left: 5px;
    margin-top: 6px;
    /* margin-top: 16px; */
    /* width: calc(100% - 50px); */
  }
  .orden-trabajo-imagenes .filter-search-icons div {
    height: 34px;
  }

  /* .card-header .propiedad-file-button {
    position: relative;
    right: 0;
  } */

  /* .propiedad-file-button {
    position: relative;
    width: 100%;
    height: 25px;
    padding-top: 2px;
    padding-bottom: 2px;
  } */
</style>